import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button, Divider} from "@mantine/core";
import classNames from "classnames";
import {defer, isEmpty} from "lodash";
import {useRef, useState} from "react";

import Review from "./Review";
import classes from "./Reviews.module.scss";
import WriteReview from "./WriteReview";
import type {Review as ReviewType, ReviewResults} from "../../graphql/types";
import type {IdSelector} from "../../lib/types";

export interface ReviewProps {
  results?: Partial<ReviewResults> | null;
  idSelector?: IdSelector | null;
  forType?: string | null;
  embedded?: boolean;
}

export default function Reviews({
  results,
  idSelector,
  forType,
  embedded = false,
}: ReviewProps) {
  const [createReview, setCreateReview] = useState<boolean>(false);
  const [createdReview, setCreatedReview] = useState<ReviewType | null>(null);
  const reviewsRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    if (!reviewsRef.current) {
      return;
    }

    reviewsRef.current.scrollTop = reviewsRef.current.scrollHeight;
  };

  const reviews = results?.reviews || [];

  return (
    <div
      className={classNames(classes.reviews, {[classes.embedded]: embedded})}
      ref={reviewsRef}>
      {createdReview && <Review review={createdReview} forType={forType} />}
      {reviews.map(review => (
        <Review key={review.id} review={review} forType={forType} />
      ))}
      {isEmpty(reviews) && !createdReview && (
        <div className={classes.noReviews}>No reviews yet</div>
      )}
      {!createReview && (
        <div>
          <Button
            size="xs"
            variant="default"
            leftSection={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => {
              setCreateReview(true);
              defer(() => scrollToBottom());
            }}>
            Write {isEmpty(reviews) && !createdReview ? "the first" : "a"}{" "}
            review
          </Button>
        </div>
      )}
      {createReview && idSelector && (
        <>
          <Divider />
          <WriteReview
            reviewInput={{...idSelector}}
            onCancel={() => setCreateReview(false)}
            onCreate={review => {
              setCreatedReview(review);
              setCreateReview(false);
            }}
          />
        </>
      )}
    </div>
  );
}
